import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/itens/item';


function TransferenciasEstadoScreen() {
    return (
        <Fragment>
            <Head titulo="Transferências de Recursos Estaduais - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1} lg={4}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <ItemBox
                            titulo={"Transferências Obrigatórias"}
                            descricao={<Fragment>Clique aqui e veja todas as transferências obrigatórias recebidas pela prefeitura realizadas pelo Estado do Rio de Janeiro.<br /><br /></Fragment>}
                            awesome={"faHandPointRight"}
                            link={"transferenciasestado/obrigatorias"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Transferências Voluntárias"}
                             descricao={<Fragment>Clique aqui e veja todas as transferências voluntárias recebidas pela prefeitura realizadas pelo Estado do Rio de Janeiro.<br /><br /></Fragment>}
                            awesome={"faHandshakeSimple"}
                            link={"transferenciasestado/voluntarias"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TransferenciasEstadoScreen;